/**
 * Auth handshake helpers shared by the axios 401 handlers.
 *
 * A 401 on login / logout / /me / token refresh is expected (expired
 * session, anonymous bootstrap probe, sign-out with a dead JWT). Those
 * must NOT bounce the browser between /login and /task — that is the
 * redirect loop reported after Logout.
 */

export function isLoginRoute(pathname) {
  const path = String(pathname || '').split('?')[0];
  return path === '/login' || path.startsWith('/login/');
}

/**
 * True when ``url`` is a credential/session probe rather than an app
 * page fetch.  Compared as path fragments so it works with both axios
 * instances (``baseURL`` ``/api`` + relative ``/super_admin/me/``, or
 * absolute ``/api/super_admin/me/``).
 */
export function isAuthHandshakeUrl(url) {
  const path = String(url || '');
  const markers = [
    '/super_admin/login/',
    '/super_admin/logout/',
    '/super_admin/me/',
    '/super_admin/token/',
    '/super_admin/password-reset/',
    '/super_admin/login-security/client-config',
  ];
  return markers.some((marker) => path.includes(marker));
}
